/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_FemaleInputs */

const en_ui_thresholds_female = /** @type {(inputs: Ui_Thresholds_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Female`)
};

const de_ui_thresholds_female = /** @type {(inputs: Ui_Thresholds_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiblich`)
};

/**
* | output |
* | --- |
* | "Female" |
*
* @param {Ui_Thresholds_FemaleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_female = /** @type {((inputs?: Ui_Thresholds_FemaleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_FemaleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_female(inputs)
	return de_ui_thresholds_female(inputs)
});